(() => {
  if (window.OSTracking) return;
  const node = document.querySelector('[data-os-tracking-config]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  let sequence = 0;
  const pending = [];
  let readinessTimer;
  const status = (envelope, state) => document.dispatchEvent(new CustomEvent('os:tracking-status', {
    detail:{operation_id:envelope.operation_id,state},
  }));
  const flush = () => {
    readinessTimer = undefined;
    const publish = window.Shopify?.analytics?.publish;
    const now = Date.now();
    while (pending.length && now - pending[0].created > 30000) {
      status(pending.shift().envelope,'sdk_unavailable');
    }
    if (typeof publish !== 'function') {
      if (pending.length) readinessTimer = setTimeout(flush,100);
      return;
    }
    while (pending.length) {
      const {envelope} = pending.shift();
      try {
        Promise.resolve(publish.call(window.Shopify.analytics,'only_snacks:commerce',envelope))
          .then(result => status(envelope,result === false ? 'not_accepted' : 'published'))
          .catch(() => status(envelope,'publish_failed'));
      } catch (_) { status(envelope,'publish_failed'); }
    }
  };
  const emit = (payload) => {
    const operationId = typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID() : `${Date.now()}-${++sequence}-${Math.random().toString(36).slice(2)}`;
    const envelope = {version:1,theme_id:String(config.theme_id),operation_id:operationId,payload};
    document.dispatchEvent(new CustomEvent('os:tracking-event', {detail:envelope}));
    if (config.transport_enabled !== true) return;
    if (pending.length >= 50) status(pending.shift().envelope,'queue_full');
    pending.push({envelope,created:Date.now()});
    if (readinessTimer === undefined) flush();
  };
  const recordAdd = (requested, response) => {
    if (!Array.isArray(requested) || !Array.isArray(response?.items)) return;
    const propertiesKey = properties => JSON.stringify(Object.entries(properties || {})
      .filter(([,value]) => value !== '' && value != null).sort(([a],[b]) => a.localeCompare(b)));
    const planId = plan => plan == null || plan === '' ? '' : String(plan);
    const grouped = new Map();
    for (const request of requested) {
      if (!request?.id) return;
      const quantity = Number(request.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const key = JSON.stringify([String(request.id),planId(request.selling_plan),propertiesKey(request.properties)]);
      const prior = grouped.get(key);
      grouped.set(key,{...request,quantity:quantity + (prior?.quantity || 0)});
    }
    const items = Array.from(grouped.values(), request => {
      const matches = response.items.filter(line => line && String(line.variant_id || line.id) === String(request.id)
        && planId(line.selling_plan_allocation?.selling_plan?.id) === planId(request.selling_plan)
        && propertiesKey(line.properties) === propertiesKey(request.properties));
      if (matches.length !== 1) return null;
      const item = matches[0];
      const quantity = Number(request.quantity);
      if (!Number.isSafeInteger(quantity) || !Number.isSafeInteger(item.quantity) || item.quantity < quantity) return null;
      const price = Number.isSafeInteger(item.final_price) && item.final_price >= 0 ? item.final_price / 100 : null;
      return {item_id:String(item.variant_id || item.id),item_name:item.title || null,
        price,quantity};
    });
    if (!items.length || items.some(item => !item)) return;
    const value = items.every(item => item.price !== null)
      ? items.reduce((sum,item) => sum + Math.round(item.price * 100) * item.quantity,0) / 100 : null;
    emit({event:'moby_product_added_to_cart',ecommerce:{currency:config.currency || null,value,items}});
  };
  window.OSTracking = {recordAdd};
  if (config.page === 'index') emit({event:'landing_viewed'});
  if (config.page === 'product' && config.product?.variant_id) {
    const product = config.product;
    const price = Number.isSafeInteger(product.price) && product.price >= 0 ? product.price / 100 : null;
    emit({event:'moby_product_viewed',ecommerce:{currency:config.currency || null,value:price,
      items:[{item_id:String(product.variant_id),item_name:product.title || null,price,quantity:1}]}});
  }
})();
